<div class="header-container">
  <div class="date-picker">
    <pdq-date-range-picker
      #datePicker
      class="date-picker"
      (onApply)="loadMetrics($event)"
      [createdAt]="shopCreated()"
      petitionType="range"
      positionRight="true"
      background="light"></pdq-date-range-picker>
  </div>

  <div class="metrics">
    @for (metric of metricList; track metric.label) {
      <metric
        class="metric"
        [suffix]="metric.suffix"
        [prefix]="metric.prefix"
        [value]="metric.value"
        [loading]="orderEditingService.metricsLoading()"
        [title]="metric.label"></metric>
    }
    @if (orderEditingService.updateRequired()) {
      <pdq-banner
        variant="attention"
        [closable]="false"
        [bannerTitle]="updateBannerTitle"
        style="width: 100%"
        button="Update App In Shopify"
        (onButtonClick)="handleAppScopeUpdate()">
        <div class="update-banner-content">
          @for (scope of requiredScopes; track scope) {
            <li>{{ scope }}</li>
          }
        </div>
      </pdq-banner>
    }
  </div>
</div>
